export interface ResumeData {
  personalInfo: {
    name: string;
    company: string;
    title: string;
    focus: string;
  };
  summary: string;
  skills: string[];
  experience: {
    position: string;
    company: string;
    responsibilities: string[];
  }[];
  contact: {
    company: string;
    focus: string;
  };
}

export class ResumeDownloader {
  private resumeData: ResumeData = {
    personalInfo: {
      name: 'Your Name',
      company: 'Quantarien',
      title: 'Founder & Lead Developer',
      focus: 'Software Development'
    },
    summary: 'Experienced software developer specializing in mobile applications, blockchain solutions, and AI integrations. Committed to delivering high-quality, scalable software solutions.',
    skills: [
      'Mobile Development (iOS/Android)',
      'Blockchain Technology',
      'AI Integration',
      'Full-Stack Development',
      'Project Management'
    ],
    experience: [
      {
        position: 'Founder & Lead Developer',
        company: 'Quantarien',
        responsibilities: [
          'Developing innovative mobile applications',
          'Implementing blockchain solutions',
          'Creating AI-powered integrations',
          'Managing end-to-end project delivery'
        ]
      }
    ],
    contact: {
      company: 'Quantarien',
      focus: 'Quality Software Development'
    }
  };

  init(): void {
    const downloadButton = document.querySelector('.download-btn');
    downloadButton?.addEventListener('click', (e) => {
      e.preventDefault();
      this.downloadResume();
    });
  }

  private generateResumeContent(): string {
    const data = this.resumeData;
    
    return `PROFESSIONAL RESUME
${data.personalInfo.company} ${data.personalInfo.focus}

SUMMARY
${data.summary}

SKILLS
${data.skills.map(skill => `• ${skill}`).join('\n')}

EXPERIENCE
${data.experience.map(exp => 
  `${exp.position} - ${exp.company}\n${exp.responsibilities.map(resp => `• ${resp}`).join('\n')}`
).join('\n\n')}

CONTACT
Company: ${data.contact.company}
Focus: ${data.contact.focus}
`;
  }

  public downloadResume(format: 'txt' | 'json' = 'txt'): void {
    try {
      let content: string;
      let filename: string;
      let mimeType: string;

      if (format === 'json') {
        content = JSON.stringify(this.resumeData, null, 2);
        filename = 'Quantarien_Resume.json';
        mimeType = 'application/json';
      } else {
        content = this.generateResumeContent();
        filename = 'Quantarien_Resume.txt';
        mimeType = 'text/plain';
      }

      const blob = new Blob([content], { type: mimeType });
      const url = window.URL.createObjectURL(blob);
      
      const downloadLink = document.createElement('a');
      downloadLink.href = url;
      downloadLink.download = filename;
      downloadLink.style.display = 'none';
      
      document.body.appendChild(downloadLink);
      downloadLink.click();
      
      // Cleanup
      window.URL.revokeObjectURL(url);
      document.body.removeChild(downloadLink);
      
      console.log(`Resume downloaded as ${filename}`);
    } catch (error) {
      console.error('Error downloading resume:', error);
      alert('Sorry, there was an error downloading the resume. Please try again.');
    }
  }

  public updateResumeData(newData: Partial<ResumeData>): void {
    this.resumeData = { ...this.resumeData, ...newData };
  }

  public getResumeData(): ResumeData {
    return { ...this.resumeData };
  }
}